import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { Api } from '../enum/Api';
import { map } from 'rxjs/operators';
import { ShopWindowManager } from '../model/shop-window-manager';

@Injectable({
  providedIn: 'root'
})

export class ShopWindowService {

  constructor(private httpService: HttpService) {}
  
  public getShopWindow(productClassification: string): Observable<any> {
    return this.httpService.post(
      'ecommerceConfig/shopWindow/getContentByfamily',
      Api.One_Portal,
      {
        'productClassification': productClassification,
      }
    ).pipe(map(result => result));
  }
}
